import React from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
// import Header from './components/Header'; // Assuming Header.js is in components/
// import Footer from './components/Footer'; // Assuming Footer.js exists
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import Result from './pages/Result';
import HealthyRelationshipSigns from './pages/blogs/HealthyRelationshipSigns';
import SelfCareAfterBreakup from './pages/blogs/SelfCareAfterBreakup';
import CommunicationTechniques from './pages/blogs/CommunicationTechniques';
import BoundariesInRelationships from './pages/blogs/BoundariesInRelationships';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Resources from './pages/Resource';
import ResourceDetail from './pages/ResourceDetail';
import FAQ from './pages/FAQ';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
//import BlogPost from './pages/BlogPost';
import WorkInProgress from './pages/Inprogress';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gradient-to-b from-indigo-50 to-white">
        {/* <Header /> */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/result" element={<Result />} />
            <Route path="/blog/healthy-relationship-signs" element={<HealthyRelationshipSigns />} />
            <Route path="/blog/self-care-after-breakup" element={<SelfCareAfterBreakup />} />
            <Route path="/blog/communication-techniques" element={<CommunicationTechniques />} />
            <Route path="/blog/boundaries-in-relationships" element={<BoundariesInRelationships />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:id" element={<ResourceDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* Uncomment when ready */}
            {/* <Route path="/blog/:id" element={<BlogPost />} /> */}
            <Route path="*" element={<WorkInProgress />} />
          </Routes>
        </main>
       
        <Analytics />
      </div>
    </Router>
  );
}

export default App;